import { styled, Typography } from '@mui/material'

export const ErrorMessage = styled(Typography)({
  wordBreak: 'break-word'
})
